import { render } from "./EditRankingVerticalModal.vue?vue&type=template&id=6b7efd68&scoped=true"
import script from "./EditRankingVerticalModal.vue?vue&type=script&lang=js"
export * from "./EditRankingVerticalModal.vue?vue&type=script&lang=js"

import "./EditRankingVerticalModal.vue?vue&type=style&index=0&id=6b7efd68&scoped=true&lang=css"

import exportComponent from "/var/www/matchmaker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b7efd68"]])

export default __exports__